/**
 * library_tab_conf Remote Config target.
 * Keep in sync with:
 *   server/src/ops-tools/library-tab-conf/library-tab-conf.rc-config.ts
 *
 * Switch to test:
 *   parameterGroup: null
 *   parameterKey: 'library_tab_conf_test'
 *   conditionSuffix: '_t'   // Neku_Android_JP_t
 */
export const LIBRARY_TAB_RC_CONFIG = {
  /** Firebase RC parameter group (null = top-level parameters) */
  parameterGroup: 'AppControls' as string | null,
  /** Firebase RC parameter key */
  parameterKey: 'library_tab_conf',
  /**
   * Appended to condition names.
   * test: '_t' → Neku_Android_t / Neku_Android_JP_t
   * prod: ''  → Neku_Android / Neku_Android_JP
   */
  conditionSuffix: '' as '' | '_t',
} as const

export type LibraryTabRcConfig = typeof LIBRARY_TAB_RC_CONFIG
